import React, { Component } from 'react';
import {Dummy} from '../'

export default class Electroentry extends Dummy {

	paintCanvas(cvs,disable, p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12,p13,p14,p15,p16,p17,p18) {
		function KVleft(power) {
            var canvas = document.getElementById('tmpcanvas');
            canvas.width = 70;
            canvas.height = 70;
            var ctx = canvas.getContext('2d');
            ctx.beginPath();
            ctx.arc(67,30,2,0,Math.PI*2,true);
            ctx.moveTo(66,30);
            ctx.lineTo(30,30);
            ctx.stroke();
            ctx.closePath();

            if (power===1) {
                ctx.fillStyle = "red";
            } else{
                ctx.fillStyle = "green";
            }

            ctx.fillRect(0,0,30,60);

            return canvas;
        };

        function KVright(power) {
            var canvas = document.getElementById('tmpcanvas');
            canvas.width = 70;
            canvas.height = 60;
            var ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.arc(3,30,2,0,Math.PI*2,true);
            ctx.moveTo(4,30);
            ctx.lineTo(40,30);
            ctx.stroke();
            ctx.closePath();

            if (power===1) {
                ctx.fillStyle = "red";
            } else{
                ctx.fillStyle = "green";
            }

            ctx.fillRect(40,0,30,60);

            return canvas;
        };

        function pump() {
            var canvas = document.getElementById('tmpcanvas');
            canvas.width = 40;
            canvas.height = 40;
            var ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.arc(20,20,20,0,Math.PI*2,true);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.arc(20,20,15,0,Math.PI*2,true);
            ctx.stroke();
            ctx.closePath();

            return canvas;
        };

        function teren() {
            var canvas = document.getElementById('tmpcanvas');
            canvas.width = 13;
            canvas.height = 100;
            var ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.arc(10,3,2,0,Math.PI*2,true);
            ctx.moveTo(10,5);
            ctx.lineTo(10,25);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.arc(10,32.5,7.5,Math.PI/2,Math.PI*3/2,false);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.arc(10,47.5,7.5,Math.PI/2,Math.PI*3/2,false);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.arc(10,62.5,7.5,Math.PI/2,Math.PI*3/2,false);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.arc(10,77.5,7.5,Math.PI/2,Math.PI*3/2,false);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.moveTo(10,85);
            ctx.lineTo(10,100);
            ctx.stroke();
            ctx.closePath();

            return canvas;
        };

        function KM(power) {
            var canvas = document.getElementById('tmpcanvas');
            canvas.width = 25;
            canvas.height = 70;
            var ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.arc(20,3,2,0,Math.PI*2,true);
            ctx.moveTo(20,5);
            ctx.lineTo(20,20);
            ctx.lineTo(15,20);
            ctx.lineTo(20,20);
            ctx.lineTo(25,20);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.arc(20,67,2,0,Math.PI*2,true);
            ctx.stroke();

            ctx.beginPath();
            if (power===1) {
                ctx.beginPath();
                ctx.moveTo(20,20);
                ctx.lineTo(20,65);
                ctx.strokeStyle = "red";
                ctx.stroke();
                ctx.closePath();
            } else {
                ctx.beginPath();
                ctx.moveTo(0,20);
                ctx.lineTo(20,65);
                ctx.strokeStyle = "green";
                ctx.stroke();
                ctx.closePath();
            }
            ctx.stroke();

            return canvas;
        };

        function QF(power) {
            var canvas = document.getElementById('tmpcanvas');
            canvas.width = 25;
            canvas.height = 70;
            var ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.arc(20,3,2,0,Math.PI*2,true);
            ctx.moveTo(20,5);
            ctx.lineTo(20,20);
            ctx.lineTo(15,20);
            ctx.lineTo(20,20);
            ctx.lineTo(25,20);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.arc(20,67,2,0,Math.PI*2,true);
            ctx.stroke();

            ctx.beginPath();
            if (power===1) {
                ctx.beginPath();
                ctx.moveTo(20,20);
                ctx.lineTo(20,65);
                ctx.strokeStyle = "red";
                ctx.stroke();
                ctx.closePath();

                ctx.strokeRect(15,30,5,20);
            } else {
                ctx.beginPath();
                ctx.moveTo(0,20);
                ctx.lineTo(20,65);
                ctx.strokeStyle = "green";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.moveTo(8,40);
                ctx.lineTo(2,43);
                ctx.lineTo(11,63);
                ctx.lineTo(17,59);
                ctx.stroke();
                ctx.closePath();

            }
            ctx.stroke();

            return canvas;
        };

       var canvas = document.getElementById(cvs);
       var ctx = canvas.getContext('2d'); 

        ctx.fillStyle = "#C5C5C4";// grey big rect
        ctx.fillRect(0,0,700,322);

        ctx.fillStyle = "#C5C5C4";// grey rects
        ctx.fillRect(0,400,80,250);
        ctx.fillRect(90,400,80,250);
        ctx.fillRect(180,400,80,250);
            

        ctx.beginPath();//left
        ctx.moveTo(150,0);
        ctx.lineTo(145,10);
        ctx.lineTo(150,0);
        ctx.lineTo(155,10);//конец стрелочки
        ctx.lineTo(150,0);
        ctx.lineTo(150,50);
        ctx.moveTo(30,50);
        ctx.lineTo(50,50);
        ctx.moveTo(117,50);
        ctx.lineTo(190,50);
        ctx.moveTo(40,118);
        ctx.lineTo(40,411);
        ctx.moveTo(128,118);
        ctx.lineTo(128,411);
        ctx.moveTo(40,50);
        ctx.lineTo(40,40);
        ctx.lineTo(127,40);
        ctx.lineTo(127,50);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(QF(1),20,49);//qf1
        ctx.drawImage(QF(p1),107,49);//qf2
        ctx.drawImage(QF(p2),160,49);//qf4        
        ctx.drawImage(KM(p3),160,114);//km1

        ctx.beginPath();
        ctx.moveTo(183,116);
        ctx.lineTo(207,116);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(KVright(p4), 206,86); //end left

        ctx.drawImage(QF(1),20,410);//AB teren EK 3
        ctx.drawImage(KM(p5),20,473);//KM teren1
        ctx.drawImage(teren(),30,537);
        ctx.drawImage(QF(1),108,410);//teren ek 1
        ctx.drawImage(KM(p6),108,473);
        ctx.drawImage(teren(),118,537);
        ctx.drawImage(QF(1),196,410);//teren ek 2
        ctx.drawImage(KM(p7),196,473);
        ctx.drawImage(teren(),206,537);
        
        ctx.drawImage(KM(p8),280,245);
        ctx.drawImage(KM(p9),355,245);
        
        ctx.beginPath();
        ctx.moveTo(180,182);
        ctx.lineTo(628,182);
        ctx.moveTo(216,250);
        ctx.lineTo(216,411);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(QF(p10),196,181);

        ctx.drawImage(QF(p11),280,181);//pump1
        ctx.beginPath();
        ctx.moveTo(300,314);
        ctx.lineTo(300,440);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(pump(),280,440);

        ctx.drawImage(QF(p12),355,181);//pump2
        ctx.beginPath();
        ctx.moveTo(375,314);
        ctx.lineTo(375,440);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(pump(),355,440);

        ctx.drawImage(QF(p13),455,181);
        ctx.beginPath();
        ctx.moveTo(475,250);
        ctx.lineTo(475,340);
        ctx.lineTo(470,330);
        ctx.lineTo(475,340);
        ctx.lineTo(480,330);
        ctx.stroke();
        ctx.closePath();

        ctx.drawImage(QF(p14),505,181);
        ctx.beginPath();
        ctx.moveTo(525,250);
        ctx.lineTo(525,340);
        ctx.lineTo(520,330);
        ctx.lineTo(525,340);
        ctx.lineTo(530,330);
        ctx.stroke();
        ctx.closePath();

        ctx.drawImage(QF(p15),555,181);
        ctx.beginPath();
        ctx.moveTo(575,250);
        ctx.lineTo(575,340);
        ctx.lineTo(570,330);
        ctx.lineTo(575,340);
        ctx.lineTo(580,330);
        ctx.stroke();
        ctx.closePath();

        ctx.drawImage(QF(1),605,181);
        ctx.beginPath();
        ctx.moveTo(625,250);
        ctx.lineTo(625,340);
        ctx.lineTo(620,330);
        ctx.lineTo(625,340);
        ctx.lineTo(630,330);
        ctx.stroke();
        ctx.closePath();

       

        ctx.drawImage(KM(p16),605,116);//right
        ctx.drawImage(QF(p17),605,52);
        ctx.drawImage(KVleft(p18), 525,89);
        ctx.beginPath();
        ctx.moveTo(594,119);
        ctx.lineTo(625,119);
        ctx.moveTo(625,0);
        ctx.lineTo(620,10);
        ctx.lineTo(625,0);
        ctx.lineTo(630,10);
        ctx.lineTo(625,0);
        ctx.lineTo(625,51);
        ctx.moveTo(615,52);
        ctx.lineTo(635,52);
        ctx.stroke();
        ctx.closePath();//end right

	};

	render() {
		return (
			<div className="col-md-8">
			<canvas className='cvs' id={this.props.canvas_id} width="700" height="700"></canvas>
				<canvas className="hidden" id="tmpcanvas"></canvas>
			</div>
		);
	}
}

Electroentry.propTypes = {
	ps: React.PropTypes.array.isRequired,
	canvas_id: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/entries/Electroentry/index.js